export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7280.d79334c0.jpg";